import { User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type LoginRequest = Pick<User, "email"> & {
  password: string;
};

export type LoginResponse = {
  user: User & UserDetailedInfo;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
};

export const login = async (body: LoginRequest): Promise<LoginResponse> => {
  const { data } = await axios.post("auth/login", body);

  return data;
};
